import React from 'react';
import styled from 'styled-components';
import InputField from 'gatsby-theme-core/src/components/form-elements/input';
import Wrapper from 'gatsby-theme-forms/src/components/input/wrapper';
import Label from 'gatsby-theme-forms/src/components/input/label';

const LicensePlateIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 115" fill="none">
    <path fill="#fff" d="M35 115h-5.292L16.72 94.282h-.145l.09 1.156c.17 2.205.253 4.22.253 6.046V115H13V89h5.238l12.95 20.611h.11c-.025-.272-.073-1.265-.145-2.978a102.06 102.06 0 0 1-.109-4.011V89H35v26zm6 0V89h4.457v22.354H57V115H41z" />
    <g fill="#FC0" clipPath="url(#a)">
      <path d="m33.5 0-1.081 3.353h-3.502l2.832 2.071-1.081 3.353L33.5 6.705l2.834 2.072-1.083-3.353 2.832-2.071h-3.5L33.5 0zm1.083 61.575L33.5 58.223l-1.081 3.352h-3.502l2.832 2.072L30.668 67l2.832-2.072L36.334 67l-1.083-3.353 2.832-2.072h-3.5zm-30-25.758 2.834 2.071-1.083-3.352 2.833-2.072h-3.5l-1.084-3.353-1.08 3.353H0l2.832 2.072-1.08 3.352 2.831-2.071zM20.125 7.252l-1.083-3.35-1.081 3.35h-3.502l2.832 2.074-1.081 3.352 2.832-2.073 2.834 2.073-1.083-3.352 2.832-2.072v-.002h-3.5zM9.54 17.908l-1.082-3.352-1.082 3.352H3.875l2.832 2.072-1.083 3.353 2.834-2.072 2.832 2.072-1.08-3.353 2.832-2.072H9.539zm3.502 29.112H9.539l-1.08-3.353-1.083 3.353H3.875l2.832 2.071-1.083 3.353 2.834-2.072 2.832 2.072-1.08-3.353 2.832-2.071zm10.583 10.655h-3.5l-1.083-3.353-1.081 3.353h-3.502l2.832 2.073-1.081 3.353 2.832-2.073 2.834 2.073-1.083-3.353 2.832-2.073zM67 32.464h-3.5l-1.083-3.353-1.081 3.353h-3.502l2.832 2.072-1.081 3.352 2.832-2.071 2.834 2.071-1.083-3.352L67 32.464zM47.958 3.901l-1.08 3.351h-3.503l2.832 2.074-1.08 3.352 2.831-2.073 2.834 2.073-1.083-3.352 2.833-2.074h-3.5l-1.084-3.35zm8.834 16.079-1.082 3.353 2.833-2.072 2.833 2.072-1.083-3.353 2.834-2.072h-3.502l-1.082-3.352-1.082 3.352h-3.502l2.833 2.072zm2.833 27.04-1.082-3.353-1.082 3.353h-3.502l2.833 2.071-1.082 3.353 2.833-2.072 2.833 2.072-1.083-3.353 2.834-2.071h-3.502zM49.041 57.675l-1.083-3.353-1.08 3.353h-3.503l2.832 2.073-1.08 3.353 2.831-2.073 2.834 2.073-1.083-3.353 2.833-2.073h-3.5z" />
    </g>
    <defs><clipPath id="a"><path fill="#fff" d="M0 0h67v67H0z" /></clipPath></defs>
  </svg>
);

const Euro = styled(({ className }) => (
  <div className={className}><LicensePlateIcon /></div>
))`
  border-radius: ${({ theme }) => theme.borderRadius} 0 0 ${({ theme }) => theme.borderRadius};
  background-color: #0972f0;
  color: white;
  display: flex;
  align-items: center;

  svg {
    width: 1rem;
    height: auto;
    margin: 0 1rem;
  }
`;

const EuroWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
`;

const StyledInputField = styled(InputField)`
  background-color: #fdd20b;
  border: 0;
  border-radius: 0 ${({ theme }) => theme.borderRadius} ${({ theme }) => theme.borderRadius} 0;
  margin: 0;
  text-transform: uppercase;
  font-weight: 900;
  font-size: 1.5rem;
  padding: 0.5rem;
  color: ${({ theme }) => theme.grayDarkColor};
`;

const LicensePlateField = ({
  className,
  name,
  label,
  required,
  onChange,
  value,
}) => (
  <Wrapper $singleColumn={!label}>
    {label && <Label required={required} $type="text">{label}</Label>}
    <EuroWrapper className={className}>
      <Euro />
      <StyledInputField
        className={className}
        type="text"
        name={name}
        required={required}
        onChange={onChange}
        value={value}
      />
    </EuroWrapper>
  </Wrapper>
);

export default styled(LicensePlateField)`

`;
